export function relativeDue(dateStr: string | null): { label: string; tone: 'overdue' | 'soon' | 'normal' | 'none' } {
  if (!dateStr) return { label: 'No deadline', tone: 'none' };
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const due = new Date(`${dateStr}T00:00:00`);
  const days = Math.round((due.getTime() - today.getTime()) / 86400000);

  if (days < 0) return { label: days === -1 ? '1 day overdue' : `${Math.abs(days)} days overdue`, tone: 'overdue' };
  if (days === 0) return { label: 'Today', tone: 'soon' };
  if (days === 1) return { label: 'Tomorrow', tone: 'soon' };
  if (days <= 7) return { label: `In ${days} days`, tone: 'soon' };
  return { label: `In ${days} days`, tone: 'normal' };
}

export function formatDate(dateStr: string | null): string {
  if (!dateStr) return '—';
  const d = new Date(`${dateStr}T00:00:00`);
  if (Number.isNaN(d.getTime())) return dateStr;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}

/** `amount` in the currency's smallest unit (e.g. cents), as Stripe reports it everywhere. */
export function formatMoney(amount: number, currency: string): string {
  return (amount / 100).toLocaleString(undefined, {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: amount % 100 === 0 ? 0 : 2,
  });
}

export function formatTimestamp(iso: string | null): string {
  if (!iso) return 'never';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const mins = Math.round((Date.now() - d.getTime()) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours} hr ago`;
  return d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}
